import { isString } from 'angular';
var PartnerKeyInterceptor = (function () {
    function PartnerKeyInterceptor($q, locationService) {
        var _this = this;
        this.$q = $q;
        this.locationService = locationService;
        this.request = function (config) {
            var isCgApiRequest = config.url.indexOf('/api/manufacturer') > -1 ||
                config.url.indexOf('/api/thirdparty') > -1 ||
                config.url.indexOf('/api/product') > -1;
            var isScApiRequest = config.method === 'GET' && (config.url.indexOf('ng-pages') > -1 || config.url.indexOf('ng-settings') > -1);
            var partnerKey = _this.locationService.get('partnerkey');
            if (isString(partnerKey) && partnerKey !== '' && (isCgApiRequest || isScApiRequest)) {
                config.url += (config.url.indexOf('?') > -1 ? '&' : '?') + ("partnerKey=" + partnerKey);
            }
            return config || _this.$q.when(config);
        };
    }
    PartnerKeyInterceptor.Factory = function ($q, locationService) {
        return new PartnerKeyInterceptor($q, locationService);
    };
    return PartnerKeyInterceptor;
}());
export { PartnerKeyInterceptor };
